module.exports = __webpack_public_path__ + "assets/img/918d6b052ef9e9ec21916eddd3c7ef55.png";